module.exports = __webpack_public_path__ + "img/grey_055.808beaf7.png";